
export default class IdleTimer {

  private thresholdMilliseconds: number;
  private timerId: number | null = null;
  private resetTimerFunction: () => any;

  constructor(thresholdMilliseconds: number, onThresholdCallback: () => any) {
    //console.log("Creating idle timer...");
    this.thresholdMilliseconds = thresholdMilliseconds;
    const resetTimerFunction = this.createResetTimer(onThresholdCallback);
    ['click', 'mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'].forEach((eventName) => {
      document.addEventListener(eventName, resetTimerFunction, true);
    });
    resetTimerFunction();
    this.resetTimerFunction = resetTimerFunction;
  }

  public reset() {
    this.resetTimerFunction();
  }

  private createResetTimer(callback: () => any) {
    return () => {
      if ( null != this.timerId ) {
        //console.log("  `--> clear timerId = " + this.timerId);
        clearTimeout(this.timerId);
      }
      this.timerId = setTimeout(() => {
        //console.log("firing callback");
        callback();
      } , this.thresholdMilliseconds);
      //console.log("  `--> new timerId = " + this.timerId);
    };
  }

}
